import { createContext, FunctionComponent, PropsWithChildren, RefObject, useContext, useMemo, useState } from 'react';

type GameGridContextType = {
  refs: {
    gameGridWrapperRef: RefObject<HTMLDivElement>;
  };
  setters: {
    setGameGridWrapperRefState?: (ref: RefObject<HTMLDivElement>) => void;
  };
};

const GameGridContext = createContext<GameGridContextType>({
  refs: {
    gameGridWrapperRef: { current: null },
  },
  setters: {},
});

export const GameGridContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [gameGridWrapperRefState, setGameGridWrapperRefState] = useState<RefObject<HTMLDivElement>>({
    current: null,
  });

  const contextValue = useMemo(
    () => ({
      refs: { gameGridWrapperRef: gameGridWrapperRefState },
      setters: { setGameGridWrapperRefState },
    }),
    [gameGridWrapperRefState]
  );

  return <GameGridContext.Provider value={contextValue}>{children}</GameGridContext.Provider>;
};

export const useGameGridContext = (): GameGridContextType => {
  return useContext(GameGridContext);
};
